









import { Component, Vue, Emit } from 'vue-property-decorator'
import {
  VQuery,
  VTable,
  QueryModel,
  TableHander,
  TableOperation
} from '@/components/table'
import { QueryDistributionActivityUserRecordList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import constant from '@/utils/constant'

@Component({
  components: {
    VQuery,
    VTable
  }
})
export default class DistributionActivityUserRecordListDialog extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    createTimeDaterange: [],
    createTimes: '',
    recordId: 0
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private show = false

  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '绿豆活动名称', param: 'distributionActivityName' },
    // { title: '活动时间', param: 'createTimeDaterange', type: 'daterange' },
    { title: '用户手机号', param: 'mobilePhone' },
    // { title: '用户名称', param: 'userName' }
  ]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '用户手机号', param: 'mobilePhone' },
    { title: '用户名称', param: 'userName' },
    { title: '绿豆活动名称', param: 'distributionActivityName' },
    { title: '绿豆数', param: 'actualNumber' },
    { title: '扣减贡献值', param: 'contributionQty' },
    { title: '扣减能量值', param: 'energyQty' },
    { title: '用户贡献值', param: 'userContributionQty' },
    { title: '用户能量值', param: 'userEnergyQty' },
    { title: '用户当前会员', param: 'currentMemberName' },

    {
      title: '分红时间',
      param: 'distributionTime',
      formatter: DateFormat,
      width: 160
    }
  ]

  public async created() {
    // this.loadData()
  }

  public async open(data: any) {
    this.queryParam.recordId = data.id
    this.show = true
    this.loadData()
  }

  @Emit('close')
  private close() {
    this.show = false
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.createTimeDaterange.length > 0) {
      param.createTimes =
        DateFormat(param.createTimeDaterange[0]) +
        ',' +
        DateFormat(param.createTimeDaterange[1])
    }
    const result = await QueryDistributionActivityUserRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
